import React from "react";
import cross_icon from "../../assets/icons/cross_icon.png";
import green_tick_icon from "../../assets/icons/green_tick_icon.png";

const TaskCompletedModal = ({ closeModal }) => {
  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container py-4 px-10 rounded-lg w-[25%]">
        <div className="flex justify-center flex-col items-center">
          <div
            className="cursor-pointer absolute right-3 top-4"
            onClick={closeModal}
          >
            <img src={cross_icon} alt="cross icon" />
          </div>

          <div>
            <img src={green_tick_icon} alt="green tick" />
          </div>
          <div className="text-[20px] my-4">Task Completed</div>
          <div className="bg-[#3fb39025] text-[14px] border border-[#3FB390] p-2 rounded-lg">
            Praveen's Task Completed, email has been sent.
          </div>
        </div>
      </div>
    </>
  );
};

export default TaskCompletedModal;
